import { Divider } from 'antd/lib'
import styles from './QuestionTitleElement.module.less'

type QuestionTitleElementProps = {
    questionCount?: {
        currentQuestion: number
        totalQuestions: number
    }
}

export const QuestionTitleElement = (props: QuestionTitleElementProps) => {
    return (
        <div className={styles['question-title-container']}>
            <p className={styles['question-title']}>FTS Exam</p>
            {props.questionCount && (
                <>
                    <Divider className={styles['divider']} type="vertical" />
                    <p
                        className={styles['question-information']}
                    >{`${props.questionCount.currentQuestion} / ${props.questionCount.totalQuestions} Question`}</p>
                </>
            )}
        </div>
    )
}
